import React, { FC, useMemo } from 'react';
import { Avatar, Popover } from 'antd';
import { getInitials } from '../../utils/DataFormatterUtils';
import { getProtectedImageUriGeneric } from '../../utils/FileAccessUtils';
import { nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { getAvatarStyle } from '../../utils/ImageUtils';

const ContactAvatarComponent: FC<any> = ({
	contact,
	size,
	hidePopover,
	style,
	popOverContent,
	...otherProps
}) => {
	const buttonSize = useMemo(() => size || 'default', [size]);

	const imgFileId = useMemo(() => {
		const arr = nullSafeGetOrElse('photoLink', contact, '').split('/');
		return arr.length > 0 && arr[0];
	}, [contact]);

	const imgFileName = useMemo(() => {
		const arr = nullSafeGetOrElse('photoLink', contact, '').split('/');
		return arr.length > 1 && arr[1];
	}, [contact]);

	const photoUri = useMemo(
		() => imgFileId && imgFileName && getProtectedImageUriGeneric(imgFileId, imgFileName),
		[imgFileId, imgFileName]
	);

	const cssStyle = useMemo(() => {
		const name =
			nullSafeGetOrElse('nameGiven', contact, '') + nullSafeGetOrElse('nameFamily', contact, '');
		return { ...(style || {}), ...getAvatarStyle(name) };
	}, [style, contact]);

	return contact ? (
		hidePopover ? (
			contact.photoLink ? (
				<Avatar
					{...otherProps}
					style={cssStyle}
					size={buttonSize}
					src={photoUri}
					alt={getInitials(contact.nameGiven, contact.nameFamily)}
				/>
			) : (
				<Avatar {...otherProps} style={cssStyle} size={buttonSize}>
					{getInitials(contact.nameGiven, contact.nameFamily)}
				</Avatar>
			)
		) : (
			<Popover
				{...otherProps}
				content={popOverContent || `${contact.nameGiven} ${contact.nameFamily}`}
			>
				{contact.photoLink ? (
					<Avatar style={cssStyle} size={buttonSize} src={photoUri} />
				) : (
					<Avatar style={cssStyle} size={buttonSize}>
						{getInitials(contact.nameGiven, contact.nameFamily)}
					</Avatar>
				)}
			</Popover>
		)
	) : null;
};

export const ContactAvatar = ContactAvatarComponent;
